import { makeStyles } from '@material-ui/core'
import themesConfig from 'app/fuse-configs/themesConfig'
import { useBreakpoints } from 'commons/useBreakpoints'

export default makeStyles((theme) => ({
  dialogWrap: {
    '& .MuiPaper-root': {
      display: 'flex',
      gap: 32,
      padding: 32,
      maxWidth: 800,
      [useBreakpoints(theme).lessThan.sm]: {
        padding: 20,
      },
      borderRadius: 16,
    },
  },

  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    padding: 0,
    color: themesConfig.default.colors.primary,
  },

  dialogTitle: {
    color: themesConfig.default.colors.primary,
    lineHeight: '24px',
    fontSize: 18,
    padding: 0,
    fontWeight: 700,
    textAlign: 'center',
  },

  dialogContent: {
    padding: 0,
    display: 'flex',
    gap: 20,
  },

  dialogActions: {
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    [useBreakpoints(theme).lessThan.sm]: {
      flexWrap: 'wrap',
    },
  },

  actionbutton1: {
    borderColor: themesConfig.default.colors.primary,
    color: themesConfig.default.colors.primary,
    '&:hover': {
      borderColor: themesConfig.default.colors.primary,
    },
  },

  actionbutton2: {
    backgroundColor: themesConfig.default.colors.primary,
    color: themesConfig.default.colors['primary-lighte'],
    '&:hover': {
      backgroundColor: themesConfig.default.colors.primary,
    },
  },
}))
